module.exports = __webpack_public_path__ + "static/media/Transport-law.ed31b811.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/Transport-law.png
// module id = 1475
// module chunks = 1